module.exports = __webpack_public_path__ + "assets/img/pay_cancel.a2f81233.png";